import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, Phone, ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';

const PHONE_NUMBER = '9099909090';

export function MobileActionBar() {
  const { totalItems } = useCart();

  const actionClassName =
    'relative flex min-h-16 flex-1 flex-col items-center justify-center gap-1 px-2 py-2 text-xs font-semibold text-gray-700 transition-colors hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-600';

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-gray-200 bg-white/95 shadow-[0_-6px_18px_rgba(0,0,0,0.12)] backdrop-blur md:hidden"
      aria-label="Quick contact actions"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="mx-auto flex max-w-lg divide-x divide-gray-200">
        <a
          href={`tel:${PHONE_NUMBER}`}
          className={actionClassName}
          aria-label="Call Vholic Appliances"
        >
          <Phone className="h-5 w-5 text-blue-700" aria-hidden="true" />
          <span>Call Now</span>
        </a>

        <a
          href={`sms:${PHONE_NUMBER}`}
          className={actionClassName}
          aria-label="Text Vholic Appliances"
        >
          <MessageCircle className="h-5 w-5 text-green-600" aria-hidden="true" />
          <span>Text Us</span>
        </a>

        <Link
          to="/cart"
          className={actionClassName}
          aria-label={`View cart${totalItems > 0 ? ` with ${totalItems} item${totalItems === 1 ? '' : 's'}` : ''}`}
        >
          <span className="relative">
            <ShoppingCart className="h-5 w-5 text-orange-600" aria-hidden="true" />
            {totalItems > 0 && (
              <span className="absolute -right-3 -top-3 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-600 px-1 text-[10px] font-bold leading-none text-white">
                {totalItems > 99 ? '99+' : totalItems}
              </span>
            )}
          </span>
          <span>View Cart</span>
        </Link>
      </div>
    </nav>
  );
}
